import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { DocumentSvg } from 'components/icons';
import { Icon, Text } from './atoms';

const template = styled.div`
  display: flex;
  align-items: center;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Icon,
      name: 'AssignmentsIcon',
      displayValue: ({ }) => DocumentSvg({ width: '11', height: '11' })
    },
    {
      component: Text,
      name: 'AssignmentsText',
      displayValue: ({ assignments }) => `${assignments ?? 0} assigned`,
    },
    {
      component: Icon,
      name: 'TimeIcon',
      displayValue: ({ }) => DocumentSvg({ width: '11', height: '11' }),
      displayState: ({ completion_time }) => ({ hide: !completion_time })
    },
    {
      component: Text,
      name: 'TimeText',
      displayValue: ({ completion_time }) => `${((completion_time ?? 1) / (24 * 60 * 60)).toFixed(1)} days`,
      displayState: ({ completion_time }) => ({ hide: !completion_time })
    },
  ]
})